import { SignupEvent } from '@/usecases/event-bus-for-third-party/event'
import { DataLayerService } from '@/vendor/gtm/data-layer'
import { signUpEventFactory } from '@/vendor/gtm/events/ga4/sign-up'

export function handleSignupEvent(_event: SignupEvent): void {
  new DataLayerService().push(signUpEventFactory.create())
}
